import moment from 'moment';
export function formatDuration(seconds) {
  const value = Number(seconds) || 0;
  return moment().startOf('day').seconds(value).format(value < 3600 ? 'mm:ss' : 'HH:mm:ss');
}
